/**
 * @param {string|number} value
 * @param {boolean} validationValue
 * @returns {boolean}
 */
function accountNo ({ value, validationValue }) {
  if (!validationValue) return true

  let val = value
  if (!val) return false

  val = value
    .toString()
    .trim()
    .replace(/[^0-9]+/g, '')

  if (!val || val.length !== 11) return false

  if (
    parseInt(val.substr(4, 1)) === 0 &&
    parseInt(val.substr(5, 1)) === 0
  ) {
    return true
  }

  const factorTable = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
  let checksum = parseInt(val.substr(10, 1))

  for (let i = 0; i < 10; ++i) {
    checksum += parseInt(val.substr(i, 1)) * factorTable[i]
  }

  return checksum - (11 * Math.floor(checksum / 11)) === 0
}

module.exports = { accountNo }
